export class Regex {
  static isValidEmail = (email: string) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

  static isDigits = (email: string) => /^[0-9]$/i.test(email);

  static isValidPassword = (password: string) => password.length >= 8;

  static filterSpecialCharacter = (value: string) =>
    value.replace(/[^a-zA-Z0-9._ ]/gm, "");

  static filterEmoji = (value: string) => {
    return value.replace(/[^a-zA-Z0-9-@./#&+\w\s ]/gm, "");
  };

  static isValidUsername = (username: string) =>
    /^[A-Z0-9._ -]{3,16}$/i.test(username);

  static isEmoji = (characters: string) => {
    return /\p{Emoji}/u.test(characters);
  };
}
